import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowRight, Save, Printer, Download } from "lucide-react";

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col gap-1 md:flex-row md:items-end md:justify-between mb-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-[#0F172A]">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2 no-print">{actions}</div>}
    </div>
  );
}

export function ActionBar({
  onBack, onNext, onSave, onPrint, onExport,
  saving, nextDisabled, hideBack, hideNext, extra,
}) {
  const nav = useNavigate();
  return (
    <div
      data-testid="action-bar"
      className="sticky bottom-0 left-0 right-0 z-10 bg-white border-t no-print mt-8 -mx-6 lg:-mx-8 px-6 lg:px-8 py-3 flex flex-wrap items-center gap-2"
      style={{ borderColor: "#E2E8F0" }}
    >
      {!hideBack && (
        <Button
          data-testid="action-back"
          variant="outline"
          className="h-12 px-5"
          onClick={onBack || (() => nav(-1))}
        >
          <ArrowLeft className="h-4 w-4 mr-2" /> Zurück
        </Button>
      )}
      {onSave && (
        <Button
          data-testid="action-save"
          className="h-12 px-6 bg-[#0A2540] hover:bg-[#113A63] text-white"
          onClick={onSave}
          disabled={saving}
        >
          <Save className="h-4 w-4 mr-2" />{saving ? "Speichern…" : "Speichern"}
        </Button>
      )}
      {onPrint && (
        <Button
          data-testid="action-print"
          variant="outline"
          className="h-12 px-5"
          onClick={onPrint || (() => window.print())}
        >
          <Printer className="h-4 w-4 mr-2" /> Drucken
        </Button>
      )}
      {onExport && (
        <Button
          data-testid="action-export"
          variant="outline"
          className="h-12 px-5"
          onClick={onExport}
        >
          <Download className="h-4 w-4 mr-2" /> Export
        </Button>
      )}
      {extra}
      <div className="flex-1" />
      {!hideNext && (
        <Button
          data-testid="action-next"
          className="h-12 px-6 bg-[#0A2540] hover:bg-[#113A63] text-white"
          onClick={onNext}
          disabled={nextDisabled}
        >
          Weiter <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      )}
    </div>
  );
}
